import { useFilterAttachmentTypeContext } from "./filter-attachment-type.context";

export function FilterAttachmentType() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterAttachmentTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}